import Component from '../../js/_Component';

export default class FooterNewsletterForm extends Component {
	private formBody: HTMLElement;

	private emailInput: HTMLInputElement;

	private emailLabel: HTMLElement;

	private zipInput: HTMLInputElement;

	private zipLabel: HTMLElement;

	private submitButton: HTMLElement;

	private successMessage: HTMLElement;

	private failureMessage: HTMLElement;

	private invalidLabelClass: string;

	private invalidInputClass: string;

	constructor(element: HTMLElement) {
		super(element);

		/** The form body. */
		this.formBody = element.querySelector('.c-footer-newsletter-form__body');

		/** The input for the email address. */
		this.emailInput = element.querySelector('#email-address');

		/** The label for the email input. */
		this.emailLabel = element.querySelector('[for="email-address"]');

		/** The input for the zip code. */
		this.zipInput = element.querySelector('#zip-code');

		/** The label for the zip input. */
		this.zipLabel = element.querySelector('[for="zip-code"]');

		/** The submit button. */
		this.submitButton = element.querySelector('.c-button');

		/** The success message. */
		this.successMessage = element.querySelector('.c-footer-newsletter-form__success-message');

		/** The failure message. */
		this.failureMessage = element.querySelector('.c-footer-newsletter-form__failure-message');

		/** The class to apply to invalid labels. */
		this.invalidLabelClass = 'c-footer-newsletter-form__label--invalid';

		/** The class to apply to invalid inputs. */
		this.invalidInputClass = 'c-footer-newsletter-form__input--invalid';

		// Add click listener to the submit button
		this.submitButton.addEventListener('click', () => this.submit());
	}

	/** Validates the form fields. */
	validate() {
		let hasError = false;

		if (!this.emailInput.value || (this.emailInput.value.indexOf('@') < 1) || (this.emailInput.value.indexOf('.') < 3)) {
			this.emailInput.classList.add(this.invalidInputClass);
			this.emailLabel.classList.add(this.invalidLabelClass);
			hasError = true;
		} else {
			this.emailInput.classList.remove(this.invalidInputClass);
			this.emailLabel.classList.remove(this.invalidLabelClass);
		}


		if ((!this.zipInput.value) || (this.zipInput.value.length < 5)) {
			this.zipInput.classList.add(this.invalidInputClass);
			this.zipLabel.classList.add(this.invalidLabelClass);
			hasError = true;
		} else {
			this.zipInput.classList.remove(this.invalidInputClass);
			this.zipLabel.classList.remove(this.invalidLabelClass);
		}

		if (hasError) {
			throw Error();
		}
	}

	/** Submits the form data. */
	submit() {
		try {
			this.validate();
		} catch (error) {
			return;
		}
		const data = {
			email: this.emailInput.value,
			zip: this.zipInput.value,
		};

		fetch('/api/email.php', {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify(data),
		})
			.then((response) => response.json())
			.then((response) => this.onSuccess(response))
			.catch(() => this.onFailure());
	}

	onSuccess(response) {
		if (!response.success) {
			this.onFailure();
			return;
		}

		this.formBody.style.display = 'none';
		this.successMessage.style.display = 'block';
	}

	onFailure() {
		this.formBody.style.display = 'none';
		this.failureMessage.style.display = 'block';
	}
}

Component.register(FooterNewsletterForm, 'FooterNewsletterForm');
